// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-XccjNFR","input":"input-2MxsAsr","check":"check-1XR63HQ"};